var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [
            { name: "el-drag-dialog", rawName: "v-el-drag-dialog" },
            { name: "dialog-drag", rawName: "v-dialog-drag" }
          ],
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("CargoMsg.Cargo_PleaseSelectTheSailingScheduleBelow"),
            width: "805px",
            "close-on-click-modal": false,
            "show-close": false,
            "custom-class": "app-main-content"
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "grid-view", staticStyle: { height: "280px" } },
            [
              _c("p", [
                _c("strong", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "BusinessIntelligence.businessIntelligenceChart.warmPrompt"
                      )
                    )
                  )
                ])
              ]),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_ChooseShippingSchedulesTips1"))
                )
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(_vm.$t("CargoMsg.Cargo_ChooseShippingSchedulesTips2"))
                )
              ]),
              _c("div", { staticClass: "main-content" }, [
                _c(
                  "div",
                  { staticClass: "section grid-wrapper" },
                  [
                    _c("cargo-ag-grid", {
                      attrs: {
                        "grid-options": _vm.gridOptions,
                        "show-side-bar": false,
                        "column-defs": _vm.columnDefs,
                        "row-data": _vm.shippingSchedules,
                        "min-height": "300px"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.enterEvent } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              ),
              _c("el-button", { on: { click: _vm.cancel } }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_NoSelectYet")))
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }